import { render, staticRenderFns } from "./termailRgisterReport.vue?vue&type=template&id=4e23222b"
import script from "./termailRgisterReport.vue?vue&type=script&lang=js"
export * from "./termailRgisterReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports